import axios from 'axios';
import _ from 'lodash';

export default function fetchContactsReports(scope, id, type, options = {}) {
  const params = _.uuCompactArrayOrObject(options);
  const request = axios.get(`/reports/${scope}/${id}/contacts/${type}`, { params });
  return request
    .then((response) => _.wget(response, 'data', { data: { values: [] } }), () => ({ data: { values: [] } }));
}
